<template>
  <div class="product-card">
    <div class="product-card-btn" v-if="product.discontinued">
      <a class="btn btn-black product-btn" :href="product.url">
        Discontinued
      </a>
    </div>

    <div class="product-card-btn" v-else>
      <a @mouseenter="prefetch" class="btn btn-alt-outline product-btn" :href="product.url" @click="gtmProductClick(product)">
        View Details
      </a>
      <button class="btn btn-alt-outline product-btn" v-if="showOrderFreeSwatchButton"
        :onclick="`dataLayer.push({'sku': '${product.sku}', 'event' : 'swatchAddToCart'});`"
        @click.prevent="addSwatchToCart">
        Order Free Swatch
      </button>
    </div>

    <a @mouseenter="prefetch" :href="product.url">
      <div class="product-card-img">
        <!-- <img class="img-effect" src="/img/spinner.gif" v-if="imgLoading"> -->
        <img class="img-effect" :src="product.featured_image_url + '?size=200'" :alt="product.name"
          v-if="product.featured_image_url">
        <img class="img-effect" src="/img/default-product-img.png?size=200" alt="image coming soon" v-else>
      </div>
    </a>

    <a @mouseenter="prefetch" :href="product.url">
      <div class="product-card-details">
        <h3 class="product-title">{{ product.name }}</h3>
        <span class="product-sku">{{ product.sku }}</span>
        <span class="product-price">{{ pricePerUnit }}</span>
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import prefetch from '../../../mixins/prefetch';

export default {
  name: 'Product',

  mixins: [prefetch],

  props: {
    product: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    orderFreeSwatchBtn: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters([
      'imgLoading'
    ]),

    showOrderFreeSwatchButton() {
      return this.product.swatch_product.enabled
        && !this.product.swatch_product.hero_only
        && !this.product.discontinued
        && !this.product.isAkzo;
    },

    currentShopPageUrl() {
      const currentPathArray = window.location.pathname.split('/');
      return currentPathArray[currentPathArray.length - 1];
    },

    pricePerUnit() {
      const formattedPrice = this.product.pricing[0]?.price_per_base_quantity.formatted ?? null;
      const unit = this.product.pricing[0]?.starting_quantity.unit ?? null;

      return (formattedPrice && unit)
        ? `${formattedPrice}/${unit === 'item' ? 'ea' : 'lb'}`
        : 'NA';
    }
  },

  methods: {
    addSwatchToCart() {
      this.$emit('add-swatch-to-cart', this.product);
    },

    gtmProductClick(product) {
      window.dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
          'click': {
            'products': [{
              'name': product.name,
              'id': product.sku,
              'price': parseFloat(product.pricing[0].price_per_base_quantity.amount),
              'brand': "Cerakote",
              'category': this.currentShopPageUrl,
              'position': this.index
            }]
          }
        }
      });

      // this is for GA4
      window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_id: undefined,
          item_list_name: undefined,
          currency: "USD",
          value: undefined,
          items: [{
            item_id: product.sku,
            item_name: product.name,
            affiliation: this.$root.me.customer_id ? this.$root.me.customer_id : undefined,
            coupon: undefined,
            currency: "USD",
            discount: undefined,
            index: this.index,
            item_brand: "Cerakote",
            item_category: product.base_quantity.unit,
            item_list_id: undefined,
            item_list_name: undefined,
            item_variant: undefined,
            location_id: "Shop Collection",
            price: parseFloat(product.pricing[0].price_per_base_quantity.amount),
            quantity: 1
          }]
        }
      });
    }
  }
}
</script>
